module.exports = __webpack_public_path__ + "static/img/des-bg-light.d8f57b5a.png";